import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import Select from "react-select";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import StoreUserSelect from "components/DropDowns/StoreUserSelect";

import { useTranslation } from "react-i18next";

function StorePage() {
  const { t } = useTranslation();

  const backRoute = "/admin/stores";
  const history = useHistory();
  const { id } = useParams();

  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [business, setBusiness] = useState("");
  const [hardwareKey, setHardwareKey] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [vatRegistry, setVatRegistry] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [addressNumber, setAddressNumber] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [city, setCity] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [geolocation, setGeolocation] = useState("");
  const [chatId, setChatId] = useState("");
  const [smsSender, setSmsSender] = useState("");
  const [smsText, setSmsText] = useState("");
  const [branchNumber, setBranchNumber] = useState(0);
  const [branchStreet, setBranchStreet] = useState("");
  const [viewSummaries, setViewSummaries] = useState(false);
  const [printSummaries, setPrintSummaries] = useState(false);
  const [emailSummaries, setEmailSummaries] = useState(false);
  const [smsSummaries, setSmsSummaries] = useState(false);
  const [clearOrders, setClearOrders] = useState(false);
  const [syncData, setSyncData] = useState(false);
  const [useIntegrations, setUseIntegrations] = useState(true);

  const [version, setVersion] = useState("");

  const [assignedLicense, setAssignedLicense] = useState({ id: 0 });

  const [selectedLicense, setSelectedLicense] = useState("");
  const [licenses, setLicenses] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");

  const [selectedUsers, setSelectedUsers] = useState([]);

  const [isDisabled, setIsDisabled] = useState(false);

  const [efoodVendorId, setEfoodVendorId] = useState("");
  const [efoodLastMileClientId, setEfoodLastMileClientId] = useState("");
  const [efoodLastMileKey, setEfoodLastMileKey] = useState("");
  const [woltVenueId, setWoltVenueId] = useState("");
  const [woltUsername, setWoltUsername] = useState("");
  const [woltPassword, setWoltPassword] = useState("");
  const [woltApiKey, setWoltApiKey] = useState("");
  const [woltSsio, setWoltSsio] = useState(false);
  const [storeUuid, setStoreUuid] = useState("");
  const [boxShopId, setBoxShopId] = useState("");
  const [gonnaOrderVenueId, setGonnaOrderVenueId] = useState("");
  const [gonnaOrderStoreId, setGonnaOrderStoreId] = useState("");
  const [gonnaOrderApiKey, setGonnaOrderApiKey] = useState("");
  const [deliveryManagerVendorId, setDeliveryManagerVendorId] = useState("");
  const [deliveryManagerGroup, setDeliveryManagerGroup] = useState("");
  const [deliveryManagerToken, setDeliveryManagerToken] = useState("");

  const [fluterStoreId, setFluterStoreId] = useState("");
  const [fluterStoreName, setFluterStoreName] = useState("");
  const [fluterRestaurantId, setFluterRestaurantId] = useState("");
  const [fluterTableId, setFluterTableId] = useState("");

  const [culizenToken, setCulizenToken] = useState("");
  const [culizenSync, setCulizenSync] = useState(false);

  const [orderooVenueId, setOrderooVenueId] = useState("");
  const [orderooToken, setOrderooToken] = useState("");

  const [ihostVenueId, setIhostVenueId] = useState("");
  const [mezepayVenueId, setMezepayVenueId] = useState("");

  const [gsisUsr, setGsisUsername] = useState("");
  const [gsisPas, setGsisPassword] = useState("");

  const [storeQrName, setStoreQrName] = useState("");
  const [storeQrAddress, setStoreQrAddress] = useState("");
  const [storeQrInfo, setStoreQrInfo] = useState("");
  const [qrOrdering, setQrOrdering] = useState(false);
  const [qrCashPayment, setQrCashPayment] = useState(false);
  const [qrCardPayment, setQrCardPayment] = useState(false);
  const [vivaStoreCode, setVivaStoreCode] = useState("");
  const [vivaMerchantId, setVivaMerchantId] = useState("");
  const [vivaIsvStoreCode, setVivaIsvStoreCode] = useState("");

  const [logoUrl, setLogoUrl] = useState("");
  const [bannerUrl, setBannerUrl] = useState("");
  const [uploadingImage, setUploadingImage] = useState("");
  const [imageInputKey, setImageInputKey] = useState(0);

  useEffect(() => {
    if (id) {
      apiService
        .get(`api/v1/stores/${id}`)
        .then((store) => {
          if (store.licenseId) {
            setAssignedLicense({
              id: store.licenseId,
              friendlyName: store.licenseFriendlyName,
              expirationDate: store.licenseExpirationDate,
            });
          } else {
            fetchUnassignedLicenses();
          }
          fillFields(store);
        })
        .catch((error) => {
          notificationService.notifyError(error.message);
          history.push(backRoute);
        });
    } else {
      fetchUnassignedLicenses();
    }
  }, []);

  const fetchUnassignedLicenses = () => {
    apiService
      .get(`api/v1/licenses/unassigned`)
      .then((response) => {
        const roles = response.data;
        const options = [];
        roles.forEach((license) => {
          options.push({
            value: license,
            label: `${license.friendlyName} (${t("common.labels.featuresSuffix")}${getAttributesLabel(license.licenseAttributes)})`,
          });
        });
        setLicenses(options);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  };

  const getAttributesLabel = (attributes) => {
    return attributes.map((item) => item.name).join(",");
  };

  const handlerStoreUserChange = (selected) => {
    console.log(selected);
    setSelectedUsers(selected);
  };

  const handleScroll = (e) => {
    e.target.blur();
  };

  const save = () => {
    setIsDisabled(true);
    const store = {
      name: name ? name : undefined,
      companyName: companyName ? companyName : null,
      business: business ? business : null,
      hardwareKey: hardwareKey ? hardwareKey : undefined,
      vatNumber: vatNumber ? vatNumber : null,
      vatRegistry: vatRegistry ? vatRegistry : null,
      phone: phone ? phone : null,
      address: address ? address : null,
      addressNumber: addressNumber ? addressNumber : null,
      postalCode: postalCode ? postalCode : null,
      city: city ? city : null,
      website: website ? website : null,
      email: email ? email : null,
      geolocation: geolocation ? geolocation : null,
      licenseId: selectedLicense ? selectedLicense.value.id : undefined,
      chatId: chatId ? chatId : null,
      smsSender: smsSender ? smsSender : null,
      smsText: smsText ? smsText : null,
      branchNumber: branchNumber,
      branchStreet: branchStreet ? branchStreet : null,
      viewSummaries: viewSummaries,
      printSummaries: printSummaries,
      emailSummaries: emailSummaries,
      smsSummaries: smsSummaries,
      clearOrders: clearOrders,
      syncData: syncData,
      useIntegrations: useIntegrations,
      version: version != null ? version + 1 : undefined,
      users: selectedUsers ? selectedUsers.map((option) => option.value) : null,
      efoodVendorId: efoodVendorId ? efoodVendorId : null,
      efoodLastMileClientId: efoodLastMileClientId ? efoodLastMileClientId : null,
      efoodLastMileKey: efoodLastMileKey ? efoodLastMileKey : null,
      woltVenueId: woltVenueId ? woltVenueId : null,
      woltUsername: woltUsername ? woltUsername : null,
      woltPassword: woltPassword ? woltPassword : null,
      woltApiKey: woltApiKey ? woltApiKey : null,
      boxShopId: boxShopId ? boxShopId : null,
      gonnaOrderVenueId: gonnaOrderVenueId ? gonnaOrderVenueId : null,
      gonnaOrderStoreId: gonnaOrderStoreId ? gonnaOrderStoreId : null,
      gonnaOrderApiKey: gonnaOrderApiKey ? gonnaOrderApiKey : null,
      deliveryManagerVendorId: deliveryManagerVendorId ? deliveryManagerVendorId : null,
      deliveryManagerGroup: deliveryManagerGroup ? deliveryManagerGroup : null,
      deliveryManagerToken: deliveryManagerToken ? deliveryManagerToken : null,
      fluterStoreId: fluterStoreId ? fluterStoreId : null,
      fluterRestaurantId: fluterRestaurantId ? fluterRestaurantId : null,
      fluterStoreName: fluterStoreName ? fluterStoreName : null,
      fluterTableId: fluterTableId ? fluterTableId : null,
      culizenToken: culizenToken ? culizenToken : null,
      ihostVenueId: ihostVenueId ? ihostVenueId : null,
      mezepayVenueId: mezepayVenueId ? mezepayVenueId : null,
      culizenSync: culizenSync ? culizenSync : null,
      orderooVenueId: orderooVenueId ? orderooVenueId : null,
      orderooToken: orderooToken ? orderooToken : null,
      gsisUsername: gsisUsr ? gsisUsr : null,
      gsisPassword: gsisPas ? gsisPas : null,
      storeQrName: storeQrName ? storeQrName : null,
      storeQrAddress: storeQrAddress ? storeQrAddress : null,
      storeQrInfo: storeQrInfo ? storeQrInfo : null,
      qrOrdering: qrOrdering,
      qrCashPayment: qrCashPayment,
      qrCardPayment: qrCardPayment,
      vivaStoreCode: vivaStoreCode ? vivaStoreCode : null,
      vivaMerchantId: vivaMerchantId ? vivaMerchantId : null,
      vivaIsvStoreCode: vivaIsvStoreCode ? vivaIsvStoreCode : null,
    };

    if (id) {
      apiService
        .putJson(`api/v1/stores/${id}`, store)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.storeSavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/stores", store)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.storeCreatedSuccessfully"));
          //history.push(`/admin/store/${resp.id}`);
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (store) => {
    setName(store.name);
    setCompanyName(store.companyName);
    setBusiness(store.business);
    setHardwareKey(store.hardwareKey);
    setVatNumber(store.vatNumber);
    setVatRegistry(store.vatRegistry);
    setPhone(store.phone);
    setAddress(store.address);
    setAddressNumber(store.addressNumber);
    setPostalCode(store.postalCode);
    setCity(store.city);
    setWebsite(store.website);
    setEmail(store.email);
    setGeolocation(store.geolocation);
    setChatId(store.chatId);
    setSmsSender(store.smsSender || "");
    setSmsText(store.smsText || "");
    setBranchNumber(store.branchNumber);
    setBranchStreet(store.branchStreet);
    setViewSummaries(store.viewSummaries);
    setPrintSummaries(store.printSummaries);
    setEmailSummaries(store.emailSummaries);
    setSmsSummaries(store.smsSummaries);
    setClearOrders(store.clearOrders);
    setSyncData(store.syncData);
    setUseIntegrations(store.useIntegrations);
    setEfoodVendorId(store.efoodVendorId);
    setEfoodLastMileClientId(store.efoodLastMileClientId);
    setEfoodLastMileKey(store.efoodLastMileKey);
    setWoltVenueId(store.woltVenueId);
    setWoltUsername(store.woltUsername);
    setWoltPassword(store.woltPassword);
    setWoltApiKey(store.woltApiKey);
    setWoltSsio(!!store.woltSsio);
    setStoreUuid(store.uuid);
    setBoxShopId(store.boxShopId);
    setGonnaOrderVenueId(store.gonnaOrderVenueId);
    setGonnaOrderStoreId(store.gonnaOrderStoreId);
    setGonnaOrderApiKey(store.gonnaOrderApiKey);
    setDeliveryManagerVendorId(store.deliveryManagerVendorId);
    setDeliveryManagerGroup(store.deliveryManagerGroup);
    setDeliveryManagerToken(store.deliveryManagerToken);
    setFluterStoreId(store.fluterStoreId);
    setFluterRestaurantId(store.fluterRestaurantId);
    setFluterStoreName(store.fluterStoreName);
    setFluterTableId(store.fluterTableId);
    setCulizenToken(store.culizenToken);
    setCulizenSync(store.culizenSync);
    setOrderooVenueId(store.orderooVenueId);
    setOrderooToken(store.orderooToken);
    setIhostVenueId(store.ihostVenueId);
    setMezepayVenueId(store.mezepayVenueId);
    setGsisUsername(store.gsisUsername);
    setGsisPassword(store.gsisPassword);
    setLogoUrl(store.logoUrl || "");
    setBannerUrl(store.bannerUrl || "");
    setStoreQrName(store.storeQrName || "");
    setStoreQrAddress(store.storeQrAddress || "");
    setStoreQrInfo(store.storeQrInfo || "");
    setQrOrdering(!!store.qrOrdering);
    setQrCashPayment(!!store.qrCashPayment);
    setQrCardPayment(!!store.qrCardPayment);
    setVivaStoreCode(store.vivaStoreCode || "");
    setVivaMerchantId(store.vivaMerchantId || "");
    setVivaIsvStoreCode(store.vivaIsvStoreCode || "");

    if (store.users && store.users.length > 0) {
      const options = [];
      for (const user of store.users) {
        options.push({
          value: user.id,
          label: user.username,
        });
      }
      setSelectedUsers(options);
    }
  };

  // type is "logo" or "banner", matching the api endpoints
  const uploadImage = (type, maxSizeMb, event) => {
    const file = event.target.files[0];
    setImageInputKey((prev) => prev + 1);
    if (!file) return;
    if (!["image/png", "image/jpeg", "image/webp"].includes(file.type)) {
      notificationService.notifyError(t("messages.onlyImageFilesAreSupported"));
      return;
    }
    if (file.size > maxSizeMb * 1024 * 1024) {
      notificationService.notifyError(t("messages.imageIsTooLarge", { size: maxSizeMb }));
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setUploadingImage(type);
    apiService
      .post(`api/v1/stores/${id}/${type}`, formData)
      .then((store) => {
        setLogoUrl(store.logoUrl || "");
        setBannerUrl(store.bannerUrl || "");
        notificationService.notifySuccess(t("messages.imageUploadedSuccessfully"));
        setUploadingImage("");
      })
      .catch((error) => {
        notificationService.notifyError(error.message || t("messages.unableToUploadImage"));
        setUploadingImage("");
      });
  };

  const renderImageUpload = (type, label, hint, url, maxSizeMb, previewStyle) => (
    <Form.Group>
      <label>{label}</label>
      <div className="mb-2" style={{ minHeight: "100px", display: "flex", alignItems: "center" }}>
        {url ? (
          <a href={url} target="_blank" rel="noopener noreferrer">
            <img src={url} alt={label} style={{ maxHeight: "100px", border: "1px solid #ddd", borderRadius: "4px", ...previewStyle }} />
          </a>
        ) : (
          <span className="text-muted">-</span>
        )}
      </div>
      <Form.Control
        key={`${type}-${imageInputKey}`}
        type="file"
        accept="image/png,image/jpeg,image/webp"
        onChange={(event) => uploadImage(type, maxSizeMb, event)}
        disabled={!!uploadingImage}
      />
      <small className="text-muted">
        {uploadingImage === type ? (
          <span>
            <i className="fa fa-circle-notch fa-spin" /> {t("messages.pleaseWait")}
          </span>
        ) : (
          hint
        )}
      </small>
    </Form.Group>
  );

  const fillCompanyInfo = () => {
    if (vatNumber.length !== 9) return;
    apiService
      .get(`api/v1/store-procedures/get-gov-data-for-vat?vatNumber=${vatNumber}`)
      .then((company) => {
        setCompanyName(_.get(company, "basic.m:onomasia", ""));
        setBusiness(_.get(company, "epaggelmata[0].m:firmActDescr", ""));
        const address = `${_.get(company, "basic.m:postalAddress", "")} ${_.get(company, "basic.m:postalAddressNo", "")}, ${_.get(company, "basic.m:postalAreaDescription", "")} ${_.get(company, "basic.m:postalZipCode", "")}`;
        setAddress(address);
        setVatRegistry(_.get(company, "basic.m:doyDescr", ""));
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        setCompanyName("");
        setBusiness("");
        setAddress("");
        setVatRegistry("");
      });
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editStore") : t("pages.titles.createStore")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.friendlyName")}</label>
                        <Form.Control
                          placeholder={t("common.labels.friendlyName")}
                          type="text"
                          value={name}
                          onChange={(event) => setName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>Hardware Key</label>
                        <Form.Control
                          placeholder="Hardware Key"
                          type="text"
                          value={hardwareKey}
                          onChange={(event) => setHardwareKey(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <h5 className="form-label">{t("common.labels.companyDetails")}</h5>
                  <Row>
                    <Col md="2" sm="12">
                      <Form.Group>
                        <label>{t("tables.headers.vatNumber")}</label>
                        <i className="text-info fa fa-cloud" style={{ marginLeft: "5px", cursor: "pointer" }} onClick={fillCompanyInfo} />
                        <Form.Control
                          placeholder={t("tables.headers.vatNumber")}
                          type="text"
                          value={vatNumber}
                          onChange={(event) => setVatNumber(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>

                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.companyName")}</label>
                        <Form.Control
                          placeholder={t("common.labels.companyName")}
                          type="text"
                          value={companyName}
                          onChange={(event) => setCompanyName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.businessActivity")}</label>
                        <Form.Control
                          placeholder={t("common.labels.businessActivity")}
                          type="text"
                          value={business}
                          onChange={(event) => setBusiness(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.address")}</label>
                        <Form.Control
                          placeholder={t("common.labels.address")}
                          type="text"
                          value={address}
                          onChange={(event) => setAddress(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>{t("tables.headers.taxOffice")}</label>
                        <Form.Control
                          placeholder={t("tables.headers.taxOffice")}
                          type="text"
                          value={vatRegistry}
                          onChange={(event) => setVatRegistry(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.phone")}</label>
                        <Form.Control
                          placeholder={t("common.labels.phone")}
                          type="text"
                          value={phone}
                          onChange={(event) => setPhone(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.branchNumberAade")}</label>
                        <Form.Control
                          placeholder={t("common.labels.branchNumber")}
                          type="number"
                          value={branchNumber}
                          onChange={(event) => setBranchNumber(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="8" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.branchAddress")}</label>
                        <Form.Control
                          placeholder={t("common.labels.branchAddress")}
                          type="text"
                          value={branchStreet}
                          onChange={(event) => setBranchStreet(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.addressNumber")}</label>
                        <Form.Control
                          placeholder={t("common.labels.addressNumber")}
                          type="text"
                          value={addressNumber}
                          onChange={(event) => setAddressNumber(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.postalCode")}</label>
                        <Form.Control
                          placeholder={t("common.labels.postalCode")}
                          type="text"
                          value={postalCode}
                          onChange={(event) => setPostalCode(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.city")}</label>
                        <Form.Control
                          placeholder={t("common.labels.city")}
                          type="text"
                          value={city}
                          onChange={(event) => setCity(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.website")}</label>
                        <Form.Control
                          placeholder={t("common.labels.website")}
                          type="text"
                          value={website}
                          onChange={(event) => setWebsite(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.email")}</label>
                        <Form.Control
                          placeholder={t("common.labels.email")}
                          type="email"
                          value={email}
                          onChange={(event) => setEmail(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>Geolocation</label>
                        <Form.Control
                          placeholder="Geolocation"
                          type="text"
                          value={geolocation}
                          onChange={(event) => setGeolocation(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  {id ? (
                    <>
                      <h5 className="form-label">{t("common.labels.storeImages")}</h5>
                      <Row>
                        <Col md="4" sm="12">
                          {renderImageUpload("logo", t("common.labels.storeLogo"), t("common.labels.storeLogoHint"), logoUrl, 2, { maxWidth: "100px" })}
                        </Col>
                        <Col md="8" sm="12">
                          {renderImageUpload("banner", t("common.labels.storeBanner"), t("common.labels.storeBannerHint"), bannerUrl, 5, { maxWidth: "100%" })}
                        </Col>
                      </Row>
                    </>
                  ) : null}

                  <h5 className="form-label">{t("common.labels.qrOrdering")}</h5>
                  <Row>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.qrStoreName")}</label>
                        <Form.Control
                          placeholder={t("common.labels.qrStoreName")}
                          type="text"
                          value={storeQrName}
                          onChange={(event) => setStoreQrName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.qrStoreAddress")}</label>
                        <Form.Control
                          placeholder={t("common.labels.qrStoreAddress")}
                          type="text"
                          value={storeQrAddress}
                          onChange={(event) => setStoreQrAddress(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.qrStoreInfo")}</label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder={t("common.labels.qrStoreInfo")}
                          value={storeQrInfo}
                          onChange={(event) => setStoreQrInfo(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-qr-ordering" checked={qrOrdering} onChange={(e) => setQrOrdering(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.qrOrderingEnabled")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-qr-cash" checked={qrCashPayment} onChange={(e) => setQrCashPayment(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.qrCashPayment")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-qr-card" checked={qrCardPayment} onChange={(e) => setQrCardPayment(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.qrCardPayment")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>Viva Merchant ID</label>
                        <Form.Control
                          placeholder="Viva Merchant ID"
                          type="text"
                          value={vivaMerchantId}
                          onChange={(event) => setVivaMerchantId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>Viva Store Code</label>
                        <Form.Control
                          placeholder="Viva Store Code"
                          type="text"
                          value={vivaStoreCode}
                          onChange={(event) => setVivaStoreCode(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>Viva ISV Store Code</label>
                        <Form.Control
                          placeholder="Viva ISV Store Code"
                          type="text"
                          value={vivaIsvStoreCode}
                          onChange={(event) => setVivaIsvStoreCode(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="form-label">{t("common.labels.specialCredentials")}</h5>
                  <Row>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>{t("messages.userSecret")}</label>
                        <Form.Control
                          placeholder={t("messages.userSecret")}
                          type="text"
                          value={gsisUsr}
                          onChange={(event) => setGsisUsername(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>Subscription Key</label>
                        <Form.Control
                          placeholder="Subscription Key"
                          type="password"
                          value={gsisPas}
                          onChange={(event) => setGsisPassword(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="form-label">E-food</h5>
                  <Row>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>Efood Vendor ID</label>
                        <Form.Control
                          placeholder="Efood Vendor ID"
                          type="text"
                          value={efoodVendorId}
                          onChange={(event) => setEfoodVendorId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>Efood Last Mile Client ID</label>
                        <Form.Control
                          placeholder="Efood Last Mile Client ID"
                          type="text"
                          value={efoodLastMileClientId}
                          onChange={(event) => setEfoodLastMileClientId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>EfoodLast Mile Key</label>
                        <Form.Control
                          placeholder="Efood Last Mile Key"
                          type="text"
                          value={efoodLastMileKey}
                          onChange={(event) => setEfoodLastMileKey(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="form-label">Wolt</h5>

                  <Row>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>Wolt Venue ID</label>
                        <Form.Control
                          placeholder="Wolt Venue ID"
                          type="text"
                          value={woltVenueId}
                          onChange={(event) => setWoltVenueId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>Wolt Username</label>
                        <Form.Control
                          placeholder="Wolt Username"
                          type="text"
                          value={woltUsername}
                          onChange={(event) => setWoltUsername(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>Wolt Password</label>
                        <Form.Control
                          placeholder="Wolt Password"
                          type="text"
                          value={woltPassword}
                          onChange={(event) => setWoltPassword(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>Wolt Api Key</label>
                        <Form.Control
                          placeholder="Wolt Api Key"
                          type="text"
                          value={woltApiKey}
                          onChange={(event) => setWoltApiKey(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  {id ? (
                    <Row>
                      <Col md="3" sm="12">
                        <Form.Group>
                          <label className="d-flex align-items-center">
                            <Form.Check type="switch" id="switch-wolt-ssio" checked={woltSsio} disabled readOnly />
                            <span className="ml-1">Wolt SSIO</span>
                          </label>
                        </Form.Group>
                      </Col>
                      <Col md="3" sm="12">
                        <Button
                          className="btn-wd btn-outline"
                          variant="primary"
                          disabled={!storeUuid}
                          onClick={() => window.open(`${process.env.REACT_APP_WOLT_SSIO_URL}&state=${storeUuid}`, "_blank", "noopener,noreferrer")}
                          style={{ width: "100%" }}
                        >
                          <i className="fa fa-link" />
                          <span>Wolt SSIO</span>
                        </Button>
                      </Col>
                    </Row>
                  ) : null}

                  <h5 className="form-label">Box</h5>
                  <Row>
                    <Col md="12" sm="12">
                      <Form.Group>
                        <label>Box Shop ID</label>
                        <Form.Control
                          placeholder="Box Shop ID"
                          type="text"
                          value={boxShopId}
                          onChange={(event) => setBoxShopId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="form-label">Gonna Order</h5>

                  <Row>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>GonnaOrder Venue ID</label>
                        <Form.Control
                          placeholder="GonnaOrder Venue ID"
                          type="text"
                          value={gonnaOrderVenueId}
                          onChange={(event) => setGonnaOrderVenueId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>GonnaOrder Store ID</label>
                        <Form.Control
                          placeholder="GonnaOrder Store ID"
                          type="text"
                          value={gonnaOrderStoreId}
                          onChange={(event) => setGonnaOrderStoreId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>GonnaOrder Api Key</label>
                        <Form.Control
                          placeholder="GonnaOrder Api Key"
                          type="password"
                          value={gonnaOrderApiKey}
                          onChange={(event) => setGonnaOrderApiKey(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="form-label">Delivery Manager</h5>
                  <Row>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>DeliveryManager Store ID</label>
                        <Form.Control
                          placeholder="DeliveryManager Store ID"
                          type="text"
                          value={deliveryManagerVendorId}
                          onChange={(event) => setDeliveryManagerVendorId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>DeliveryManager Group</label>
                        <Form.Control
                          placeholder="DeliveryManager Group"
                          type="text"
                          value={deliveryManagerGroup}
                          onChange={(event) => setDeliveryManagerGroup(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="4" sm="12">
                      <Form.Group>
                        <label>DeliveryManager Token</label>
                        <Form.Control
                          placeholder="DeliveryManager Token"
                          type="password"
                          value={deliveryManagerToken}
                          onChange={(event) => setDeliveryManagerToken(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="form-label">Fluter</h5>
                  <Row>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>Fluter Store ID</label>
                        <Form.Control
                          placeholder="Fluter Store ID"
                          type="text"
                          value={fluterStoreId}
                          onChange={(event) => setFluterStoreId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>Fluter Store Name</label>
                        <Form.Control
                          placeholder="Fluter Store Name"
                          type="text"
                          value={fluterStoreName}
                          onChange={(event) => setFluterStoreName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>Fluter Restaurant ID</label>
                        <Form.Control
                          placeholder="Fluter Restaurant ID"
                          type="text"
                          value={fluterRestaurantId}
                          onChange={(event) => setFluterRestaurantId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="12">
                      <Form.Group>
                        <label>Fluter Table ID</label>
                        <Form.Control
                          placeholder="Fluter Table ID"
                          type="text"
                          value={fluterTableId}
                          onChange={(event) => setFluterTableId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <h5 className="form-label">Culizen</h5>
                  <Row>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>Culizen Token</label>
                        <Form.Control
                          placeholder="Culizen Token"
                          type="password"
                          value={culizenToken}
                          onChange={(event) => setCulizenToken(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label></label>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-199" checked={culizenSync} onChange={(e) => setCulizenSync(e.target.checked)} />
                          <span className="ml-1">Culizen Sync</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                  <h5 className="form-label">Orderoo</h5>
                  <Row>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>Orderoo Venue ID</label>
                        <Form.Control
                          placeholder="Orderoo Venue ID"
                          type="text"
                          value={orderooVenueId}
                          onChange={(event) => setOrderooVenueId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>Orderoo Token</label>
                        <Form.Control
                          placeholder="Orderoo Token"
                          type="password"
                          value={orderooToken}
                          onChange={(event) => setOrderooToken(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <h5 className="form-label">i-host</h5>
                  <Row>
                    <Col md="12" sm="12">
                      <Form.Group>
                        <label>i-host Venue Id</label>
                        <Form.Control
                          placeholder=""
                          type="text"
                          value={ihostVenueId}
                          onChange={(event) => setIhostVenueId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <h5 className="form-label">MezePay</h5>
                  <Row>
                    <Col md="12" sm="12">
                      <Form.Group>
                        <label>MezePay Venue Id</label>
                        <Form.Control
                          placeholder=""
                          type="text"
                          value={mezepayVenueId}
                          onChange={(event) => setMezepayVenueId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="form-label">Telegram</h5>
                  <Row>
                    <Col md="12" sm="12">
                      <Form.Group>
                        <label>Telegram Chat ID</label>
                        <Form.Control
                          placeholder="Telegram Chat ID"
                          type="text"
                          value={chatId}
                          onChange={(event) => setChatId(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="form-label">SMS</h5>
                  <Row>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.smsSender")}</label>
                        <Form.Control
                          placeholder={t("common.labels.smsSender")}
                          type="text"
                          value={smsSender}
                          onChange={(event) => setSmsSender(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6" sm="12">
                      <Form.Group>
                        <label>{t("common.labels.smsText")}</label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder={t("common.labels.smsText")}
                          value={smsText}
                          onChange={(event) => setSmsText(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="form-label">{t("common.labels.technicalDetails")}</h5>
                  <Row>
                    <Col md="3" sm="3">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-1" checked={viewSummaries} onChange={(e) => setViewSummaries(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.viewBalances")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="3">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-2" checked={printSummaries} onChange={(e) => setPrintSummaries(e.target.checked)} />
                          <span className="ml-1">{t("common.actions.printBalances")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="3">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-3" checked={emailSummaries} onChange={(e) => setEmailSummaries(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.emailBalances")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="3">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-4" checked={smsSummaries} onChange={(e) => setSmsSummaries(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.smsBalances")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="3" sm="3">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-5" checked={clearOrders} onChange={(e) => setClearOrders(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.clearOrders")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="3">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-6" checked={syncData} onChange={(e) => setSyncData(e.target.checked)} />
                          <span className="ml-1">Cloud</span>
                        </label>
                      </Form.Group>
                    </Col>
                    <Col md="3" sm="3">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-7" checked={useIntegrations} onChange={(e) => setUseIntegrations(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.useIntegration")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>

                  {assignedLicense.id ? (
                    <Form.Group>
                      <label>{t("common.labels.assignedLicense")}</label>
                      <div>
                        <strong>{assignedLicense.friendlyName}</strong>
                      </div>
                    </Form.Group>
                  ) : (
                    <Form.Group>
                      <label>{t("common.labels.assignLicense")}</label>
                      <Select
                        className="primary"
                        name="singleSelect"
                        value={selectedLicense}
                        onChange={(value) => setSelectedLicense(value)}
                        options={licenses}
                        placeholder={t("forms.placeholders.selectLicense")}
                        noOptionsMessage={() => t("messages.youHaveNoAvailableLicenses")}
                      />
                    </Form.Group>
                  )}

                  <StoreUserSelect selectedUsers={selectedUsers} handler={handlerStoreUserChange} />
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default StorePage;
